/* eslint-disable camelcase */
/* eslint-disable jsx-quotes */
import React from 'react';

import './styles.css';

export default class ItemOptionPresentation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            option,
            // showAllTextOption,
            // handleShowAllTextOption,
            correct_question_id,
        } = this.props;
        return (
            <div className="container-option-details">
                <span className="header">
                    <span className="description">
                        <span
                            className={
                                !(option.id === correct_question_id)
                                    ? 'indicate-correct'
                                    : 'indicate-correct highlight-correct'
                            }
                        >
                            {option.id === correct_question_id && (
                                <span className="checkmark"></span>
                            )}
                        </span>
                        <p>{option.title}</p>
                    </span>
                </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/questions-database/components/ItemOption/ItemOptionPresentation.js